<template>
  <li class="has-sub user-chat">
    <router-link
      :to="`/personal-channel/${chat.id}`"
      tag="a"
    >
      <span class="user-chat__img">
        <img
          v-if="chat.photo"
          :src="chat.photo | imgSrc"
          alt
        />
        <img
          v-else
          :src="env.public_base + '/assets/images/person-icon.png'"
          alt
        />
      </span>

      <span
        class="user-status"
        :class="{'is-online' : chat.is_online}"
      ></span>

      <p v-if="chat.name">{{chat.name}}</p>

      <p
        v-if="chat.first_name || chat.last_name || chat.patronymic"
      >{{chat.last_name}} {{chat.first_name}} {{chat.patronymic}}</p>

      <div
        class="sub__notification sub__notification--personal"
        v-if="notifications && notifications > 0"
      >{{notifications}}</div>
    </router-link>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';
import env from '../../env';

export default {
  props: ['chat', 'chats'],
  data: () => ({
    env,
  }),
  computed: {
    ...mapGetters(['userData', 'chatsWithMe']),
    notifications() {
      return this.chats[this.chats.indexOf(this.chat)].unread_messages_count;
      // for (let [index, obj] of this.chatsWithMe.entries()) {
      //     obj = Object.assign({}, obj, {'id_current_chat_member_0': obj.members[0].id }, {'id_current_chat_member_1': obj.members[1] ? obj.members[1].id : false});
      //
      //     if (obj.id_current_chat_member_0 == this.chat.id || obj.id_current_chat_member_1 == this.chat.id) {
      //         return obj.unread_messages_count <= 0 ? false : obj.unread_messages_count;
      //     }
      // }
    },
  },
};
</script>

<style lang="scss">
.user-chat__img {
  display: inline-block;
  width: 30px;
  height: 30px;
}
</style>
